import { Column } from '../../../../hooks/useTablePages';

const columns: Column[] = [
  {
    header: 'Name',
    accessor: 'name',
    width: 300,
  },
  {
    id: 'phones.value',
    header: 'Phone',
    accessor: (row: any) => row.phones[0]?.value,
    width: 140,
  },
  {
    id: 'emails.value',
    header: 'Email',
    accessor: (row: any) => row.emails[0]?.value,
    width: 300,
  },
  {
    header: 'Address',
    id: 'contactAddress.street1',
    accessor: (row: any) =>
      (row.contactAddress?.street1 ? row.contactAddress.street1 : '') +
      (row.contactAddress?.street2 ? ', ' + row.contactAddress.street2 : ''),
    width: 300,
  },
  {
    header: 'City',
    accessor: 'contactAddress.city',
    width: 120,
  },
  {
    header: 'State',
    accessor: 'contactAddress.state',
    width: 60,
  },
  {
    header: 'Zip',
    id: 'contactAddress.zip',
    accessor: (row: any) =>
      (row.contactAddress?.zip ? row.contactAddress.zip : '') +
      (row.contactAddress?.zipExt ? '-' + row.contactAddress.zipExt : ''),
    width: 120,
  },
];

export default columns;
